import React from 'react'
import { Jumbotron } from 'react-bootstrap'
import defaultBanner from 'images/oly_banner.png'
import styled from '@emotion/styled'


const TrickedJumbotron = styled(Jumbotron)`
  label:TrickedJumbotron;
  background-color: ${(props) => props.theme.backgrounds.backGround1};
  background-image: ${(props) => props.src ? `url(${props.src})`: `url(${defaultBanner})`};
  @media (max-width: 1070px) {
    background-image: ${(props) => props.src && 'none'};
  }
`


const BannerMainImageSection = (props) => {
  return (
    <TrickedJumbotron src={props.src}
      fluid
      className="mb-0 banner-main-bg banner-bg"
    >
      <div className="banner-container font-weight-bold">
        <div className="banner-content">{props.children}</div>
      </div>
    </TrickedJumbotron>
  )
}

export default BannerMainImageSection
